export const FETCH_DELAY_TIMEOUT = 300000;
